<!--
 * @Author: your name
 * @Date: 2022-04-28 15:26:42
 * @LastEditTime: 2022-04-28 17:24:35
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ant-design-vue-jeecg\src\views\modules\okr\ShowAllPlan copy.vue
-->
<template>
  <a-card :bordered="false" style="height: 100%; padding-bottom: 200px">
    <div class="table-page-search-wrapper">
      <a-form-model ref="form" :model="model" layout="inline">
        <!--  通过部门选择用户控件 -->
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="选择总结" prop="groupId">
              <j-dict-select-tag
                v-model="model.groupId"
                placeholder="选择总结"
                dictCode="okr_group,name,id"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="选择用户" prop="userIds">
              <j-select-user-by-dep
                v-model="model.userIds"
                :multi="true"
                store="id"
                :myDept="true"
              ></j-select-user-by-dep>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-button @click="handleQuery" type="primary" icon="plus">查询</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="打分结果列表" key="1">
        <mark-summary-revise-list ref="list" />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import Vue from 'vue'
import MarkSummaryReviseList from './modules/MarkSummaryReviseList.vue'

export default Vue.extend({
  name: 'MarkResultList',
  components: { MarkSummaryReviseList },
  data() {
    return {
      model: {},
      // 表头
    }
  },
  methods: {
    handleQuery() {
      this.$refs.list.handleQuery1(this.model)
    },
  },
})
</script>
<style lang="less" scoped>
.ant-card-body .table-operator {
  margin-bottom: 18px;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 15px;
  padding-bottom: 15px;
}

.anty-row-operator button {
  margin: 0 5px;
}

.ant-btn-danger {
  background-color: #ffffff;
}

.ant-modal-cust-warp {
  height: 100%;
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto;
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden;
}
</style>